import { Box, Toolbar } from "@mui/material";
import { ResponsiveMain } from "../../../../shared/ui/layout";
import { AuthorizedNavigation } from "../../../../widgets/auth-nav";
import { useDrawerToggler } from "../models/useDrawerToggler";

interface AuthenticatedPageLayoutProps {
    children?: React.ReactNode;
}

/**
 * AuthenticatedPageLayout
 *
 * Layout component for authenticated pages. Renders the authorized navigation (sidebar/drawer)
 * and the main content area. Manages drawer state and layout responsiveness.
 *
 * @param children - The main content to render inside the layout
 */
export const AuthenticatedPageLayout: React.FC<
    AuthenticatedPageLayoutProps
> = ({ children }) => {
    const layoutState = useDrawerToggler();

    return (
        <Box sx={{ display: "flex" }}>
            <AuthorizedNavigation
                open={layoutState.drawerOpen}
                isMobile={layoutState.isMobile}
                onDrawerToggle={layoutState.toggleDrawer}
                onWidthChange={layoutState.handleWidthChange}
            />

            {(layoutState.drawerReady || layoutState.isMobile) && (
                <ResponsiveMain
                    isMobile={layoutState.isMobile}
                    drawerWidth={layoutState.drawerWidth}
                >
                    <Toolbar />
                    {children}
                </ResponsiveMain>
            )}
        </Box>
    );
};
